<template>
  <v-simple-table fixed-header height="500px" v-if="listetabs!=null&& listetabs.length>0">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Identifiant
                  </th>
                   <th class="text-left">
                    Siret
                  </th>
                  <th class="text-left">
                    Etablissement
                  </th>
                  <th class="text-left">
                    Adresse
                  </th>
                   <th class="text-left">
                    Famille
                  </th>
                  <th class="text-left">
                    Régime
                  </th>
                  <th class="text-left">
                    Seveso
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="item in listetabs"
                    v-bind:key="item.code_s3ic"
                >
                  <td><a :href="item.url_fiche" target="_blank">{{ item.code_aiot }}</a></td>
                  <td><a @click="displaySelected(item.siret)"><v-icon x-small v-if="item.siret!=''">mdi-open-in-new</v-icon> {{ item.siret ? item.siret : "" }}</a>

                  <td>{{ item.nomEtablisemment }}</td>
                  <td>{{ item.codePostal }} {{ item.nomCommune }}</td>
                  <td>{{ item.famille_ic }}</td>
                  <td>{{ item.libRegime }}</td>
                  <td>{{ item.lib_seveso }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
</template>

<script>
export default {
  name: "ipce",
  props: ["listetabs"],
  methods : {
     displaySelected(siret) {
        this.$store.dispatch('getEtablissement',siret)
    },
  }
}
</script>

<style scoped>

</style>